import { absoluteCenter } from '$shared/utils';
import styled from '@emotion/styled';
export const StyledNoMarketingConsent = styled.div(() => ({
    ...absoluteCenter,
}));
